<script>
import {mapState, mapMutations} from 'vuex'

import ModalCloseButton from "@/components/core/ModalCloseButton.vue";
import templatable from "@/mixins/templatable";
import BidPlacedMessage from "@/components/max-bid-created-modal/BidPlacedMessage.vue";
import YourMaxBid from "@/components/max-bid-created-modal/YourMaxBid.vue";
import {getIncrements} from "@/helpers";
import BidIncrement from "@/components/max-bid-created-modal/BidIncrement.vue";
import BidDate from "@/components/max-bid-created-modal/BidDate.vue";
import dynamicFieldsMixin from "@/mixins/dynamicFieldsMixin";

export default {
  name: "MaxBidCreatedModal",
  components: {ModalCloseButton, BidPlacedMessage, YourMaxBid, BidIncrement, BidDate},
  mixins: [templatable('maxBidCreatedModalTemplate'), dynamicFieldsMixin],
  data() {
    return {
      template: `
        <b-modal v-if="lot"
           :id="maxBidCreatedModal.id || 'maxBidCreatedModal'"
           v-model="maxBidCreatedModal.show"
           header-bg-variant="light"
           header-text-variant="dark"
           ok-only
           ok-variant="secondary"
           :ok-title="$t('Close')"
           static
           centered>
          <template #modal-header="{ close }">
            <h5 class="modal-title"
                v-html="$options.filters.stripTags($options.filters.currentLocale(lot.title))"></h5>
            <ModalCloseButton @click="closeModal()" />
          </template>
          [[template]]
        </b-modal>
      `
    }
  },
  computed: {
    ...mapState(['maxBidCreatedModal', 'customer']),
    ...mapState({
      lot: state => state.maxBidCreatedModal.lot,
      bid: state => state.maxBidCreatedModal.bid,
    }),
    increments() {
      return getIncrements(this.lot)
    },
  },
  methods: {
    ...mapMutations(['hideMaxBidCreatedModal']),
    closeModal() {
      this.hideMaxBidCreatedModal()
    },
  }
}
</script>

<style lang="scss">
  @import "../bootstrap/import";

  .ta-max-bid-created-modal-data {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid $gray-200;
  }
</style>
